import React from 'react';

import { BlockAdultsWithLowAssurance } from '@components/block-adults-with-low-assurance';
import {
    AndroidWalletLowAssuranceWarning,
    GoogleWalletInfoBanner,
    GoogleWalletStepByStep,
} from '@domain/digital-wallet';
import useText from '@hooks/use-text';

export const GoogleWalletPage = (): JSX.Element => {
    const { googleWalletName } = useText();

    return (
        <div className="sgw-layout medium-centered-container">
            <div className="sgw-layout-item">
                <BlockAdultsWithLowAssurance
                    lowAssuranceWarning={<AndroidWalletLowAssuranceWarning />}
                    onlyNativeAllowedWarning={null!}
                >
                    <section className="google-wallet-page">
                        <h1 className="h1" data-testid="google-wallet-header">
                            {googleWalletName}
                        </h1>
                        <GoogleWalletInfoBanner />
                        <GoogleWalletStepByStep />
                    </section>
                </BlockAdultsWithLowAssurance>
            </div>
        </div>
    );
};
